interface Option {
  label: string;
  value: string;
}

interface FilterChipsProps {
  label: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterChips({
  label,
  options,
  value,
  onChange,
}: FilterChipsProps) {
  return (
    <div className="flex items-start gap-3">
      <span className="shrink-0 pt-1.5 text-sm text-foreground-500 whitespace-nowrap">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`px-3 py-1.5 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}